import { render } from "./ManagerList.vue?vue&type=template&id=2bcfd3f6"
import script from "./ManagerList.vue?vue&type=script&lang=js"
export * from "./ManagerList.vue?vue&type=script&lang=js"

import "./ManagerList.vue?vue&type=style&index=0&id=2bcfd3f6&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__